<template>
  <div>
    <el-drawer
      title=""
      :visible.sync="showDrawer"
      :with-header="false"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
    >
      <div class="addDrawerTitle">
        {{ drawerTitle }}
      </div>
      <el-form
        v-if="drawerType == 'addRoot' || drawerType == 'editRoot'"
        ref="userFormAddRoot"
        :model="rootForm"
        class="searchForm"
        :rules="rootFormRules"
      >
        <el-form-item
          :label="$t(`authorization.organization.orgCode`)"
          prop="orgCode"
        >
          <!-- <el-select  disabled v-model="rootForm.orgCode" :placeholder="$t(`common.pleaseSelect`)" >
            <el-option v-for="item in addType" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select> -->
          <el-input
            v-model="rootForm.orgCode"
            :placeholder="$t(`common.pleaseInput`)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.engName`)"
          prop="orgName"
        >
          <el-input
            v-model="rootForm.orgName"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.chName`)"
          prop="orgNameCn"
        >
          <el-input
            v-model="rootForm.orgNameCn"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t(`common.status`)" prop="status">
          <el-select
            v-model="rootForm.status"
            :placeholder="$t(`common.pleaseSelect`)"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t(`common.place`)" prop="area">
          <el-select
            clearable
            class="shortSelect"
            value-key="code"
            style="width: 120px !important"
            v-model="rootForm.province"
            filterable
            size="small"
            @change="selectProvinceFun($event)"
            :placeholder="$t(`authorization.organization.selectProvince`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in province"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            clearable
            class="shortSelect"
            style="width: 120px !important"
            value-key="code"
            v-model="rootForm.city"
            filterable
            size="small"
            @change="selectCityFun($event)"
            :placeholder="$t(`authorization.organization.selectCity`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in cityList"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            clearable
            value-key="code"
            class="shortSelect"
            style="width: 120px !important"
            v-model="rootForm.area"
            filterable
            size="small"
            @change="selectAreaFun($event)"
            :placeholder="$t(`authorization.organization.selectArea`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in areaList"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.placeDetail`)"
          prop="address"
        >
          <el-input
            v-model="rootForm.address"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.phone`)"
          prop="telephone"
        >
          <el-input
            v-model="rootForm.telephone"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`common.remark`)"
          prop="remark"
          style="height: 140px"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="rootForm.remark"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-form
        v-if="drawerType == 'addChild' || drawerType == 'editChild'"
        ref="userFormAddChild"
        :model="childForm"
        class="searchForm"
        :rules="
          childForm.type == 'DEPARTMENT' ? childFormRules1 : childFormRules2
        "
      >
        <el-form-item
          :label="$t(`authorization.organization.selectAddType`)"
          prop="type"
        >
          <el-select
            v-model="childForm.type"
            :placeholder="$t(`common.pleaseSelect`)"
          >
            <el-option
              v-for="item in addChildType"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.orgCode`)"
          prop="orgCode"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.orgCode"
            :placeholder="$t(`common.pleaseInput`)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.positionCode`)"
          prop="positionCode"
          v-if="childForm.type == 'POSITION'"
        >
          <el-input
            v-model="childForm.positionCode"
            :placeholder="$t(`common.pleaseInput`)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.engName`)"
          prop="orgName"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.orgName"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.engName`)"
          prop="positionName"
          v-if="childForm.type == 'POSITION'"
        >
          <el-input
            v-model="childForm.positionName"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.chName`)"
          prop="orgNameCn"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.orgNameCn"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.chName`)"
          prop="positionNameCn"
          v-if="childForm.type == 'POSITION'"
        >
          <el-input
            v-model="childForm.positionNameCn"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item
          label="岗位类型"
          prop="positionType"
          v-if="childForm.type == 'POSITION'"
        >
          <el-input
            v-model="childForm.positionType"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item> -->
        <el-form-item
          :label="$t(`authorization.organization.sequence`)"
          prop="orgSequence"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.orgSequence"
            :placeholder="$t(`common.pleaseInput`)"
            maxlength="10"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.sequence`)"
          prop="positionSequence"
          v-if="childForm.type == 'POSITION'"
        >
          <el-input
            v-model="childForm.positionSequence"
            :placeholder="$t(`common.pleaseInput`)"
            maxlength="10"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`common.status`)"
          prop="status"
          v-if="childForm.type == 'POSITION' || childForm.type == 'DEPARTMENT'"
        >
          <el-select
            v-model="childForm.status"
            :placeholder="$t(`common.pleaseSelect`)"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`common.place`)"
          prop="area"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-select
            clearable
            class="shortSelect"
            value-key="code"
            style="width: 120px !important"
            v-model="childForm.province"
            filterable
            size="small"
            @change="selectProvinceFun($event)"
            :placeholder="$t(`authorization.organization.selectProvince`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in province"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            clearable
            class="shortSelect"
            style="width: 120px !important"
            value-key="code"
            v-model="childForm.city"
            filterable
            size="small"
            @change="selectCityFun($event)"
            :placeholder="$t(`authorization.organization.selectCity`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in cityList"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            clearable
            value-key="code"
            class="shortSelect"
            style="width: 120px !important"
            v-model="childForm.area"
            filterable
            size="small"
            @change="selectAreaFun($event)"
            :placeholder="$t(`authorization.organization.selectArea`)"
          >
            <el-option
              :value="item"
              :label="$t(item.name)"
              v-for="item in areaList"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.placeDetail`)"
          prop="address"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.address"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`authorization.organization.phone`)"
          prop="telephone"
          v-if="childForm.type == 'DEPARTMENT'"
        >
          <el-input
            v-model="childForm.telephone"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`common.remark`)"
          prop="remark"
          v-if="childForm.type == 'POSITION' || childForm.type == 'DEPARTMENT'"
          style="height: 100px"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="childForm.remark"
            :placeholder="$t(`common.pleaseInput`)"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="bottomBtns" :class="addClass">
        <el-button
          class="yesBtn"
          @click="confirm()"
          type="primary"
          v-show="drawerType != 'addChild' || childForm.type"
          >{{ $t(`common.confirm`) }}</el-button
        >
        <el-button class="noBtn" @click="setDrawer(false)">{{
          $t(`common.cancel`)
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import province from "@/components/ClFrame/json/third-level-address.json";
export default {
  name: "LeftDrawer",
  props: {
    drawerType: {
      type: String,
      default: "",
    },
    drawerTitle: {
      type: String,
      default: "",
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
    addoreditForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      statusList: [
        { label: this.$t(`common.forbid`), value: "F" },
        { label: this.$t(`common.normal`), value: "N" },
      ],
      // 整个省市县数据
      province: province,
      // 被选中的市数据
      cityList: [],
      // 被选中的县数据
      areaList: [],
      rootForm: {
        orgCode: "",
        orgName: "",
        orgNameCn: "",
        orgType: "ORG",
        address: "",
        telephone: "",
        province: "",
        city: "",
        area: "",
        orgKind: "",
        status: "",
        remark: "",
      },
      childForm: {},
      rootFormRules: {
        orgCode: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        orgName: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        orgNameCn: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t(`common.pleaseSelect`),
            trigger: "change",
          },
        ],
      },
      childFormRules1: {
        type: [
          {
            required: true,
            message: this.$t(`common.pleaseSelect`),
            trigger: "change",
          },
        ],
        orgCode: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        orgName: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        orgNameCn: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t(`common.pleaseSelect`),
            trigger: "change",
          },
        ],
        orgSequence: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
      },
      childFormRules2: {
        type: [
          {
            required: true,
            message: this.$t(`common.pleaseSelect`),
            trigger: "change",
          },
        ],
        positionCode: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        positionName: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        positionNameCn: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        positionSequence: [
          {
            required: true,
            message: this.$t(`common.pleaseInput`),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t(`common.pleaseSelect`),
            trigger: "change",
          },
        ],
      },
      addType: [
        { value: "ORG", label: this.$t(`common.normal`) },
        {
          value: "DEPARTMENT",
          label: this.$t(`authorization.organization.department`),
        },
        {
          value: "POSITION",
          label: this.$t(`authorization.organization.position`),
        },
      ],
      addChildType: [
        {
          value: "DEPARTMENT",
          label: this.$t(`authorization.organization.department`),
        },
        {
          value: "POSITION",
          label: this.$t(`authorization.organization.position`),
        },
      ],
      //   loginFormRules: {},
      //   userFormRules: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      tableType: "",
      tableData: {},
      loginForm: {},
      userForm: {},
      true: true,
      false: false,
      addClass: "",
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            { type: "query", name: `common.query`, event: "query" },
            { type: "add", name: `common.add`, event: "addResourceGroup" },
            { type: "remove", name: `common.remove`, event: "remove" },
          ],
        },
        table: {
          selection: true,
          columns: [
            { prop: "name", label: `common.name`, width: "" },
            { prop: "ID", label: `common.ID`, width: "" },
            { prop: "email", label: `common.ID`, width: "" },
            { prop: "job", label: `common.position`, width: "" },
            { prop: "status", label: `common.status`, width: "" },
          ],
          action: {},
        },
      },
    };
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  mounted() {
    this.$nextTick(() => {
      let drawerHeight =
        document.getElementsByClassName("el-drawer__body")[0].scrollHeight;
      let screenHeight = window.screen.height;
      console.log("drawerHeight", drawerHeight);
      console.log("screenHeight", screenHeight);
      if (drawerHeight > screenHeight) {
        //按钮固定在抽屉下方
        this.addClass = "fixedBottom";
      } else {
        this.addClass = "";
      }
    });
    //编辑根机构
    if (this.drawerType == "editRoot") {
      this.rootForm = this.addoreditForm;
    } else if (this.drawerType == "editChild") {
      this.childForm = this.addoreditForm;
    }
  },
  methods: {
    // 省份 市 县联动
    selectProvinceFun(event) {
      console.log("event", event);
      if (event) {
        this.cityList = event.children;
      } else {
        this.cityList = [];
      }
      this.areaList = [];
      this.childForm.city = {};
      this.childForm.area = {};
      this.rootForm.city = {};
      this.rootForm.area = {};
      this.$emit("getLawyerListInfo", [event.name, "province"]);
      console.log("this.rootForm", this.rootForm);
    },
    selectCityFun(event) {
      console.log("event", event);
      if (event) {
        this.areaList = event.children;
      } else {
        this.areaList = [];
      }
      this.childForm.area = {};
      this.rootForm.area = {};
      this.$emit("getLawyerListInfo", [event.name, "city"]);
    },
    selectAreaFun(event) {
      console.log("event", event);
      this.$emit("getLawyerListInfo", [event.name, "area"]);
    },
    // clickInput(prop){
    //     console.log('prop',prop)
    // },
    callBackAction(param) {
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    query() {},
    addResourceGroup() {
      this.$emit("addResourceGroup");
    },
    add() {},
    remove(items) {
      this.$emit("deleteResourceGroup", items.selectedItems);
    },
    setDrawer(v) {
      this.$emit("changeDrawer", v);
    },
    confirm() {
      if (this.drawerType == "addRoot" || this.drawerType == "editRoot") {
        this.$refs["userFormAddRoot"].validate((valid) => {
          if (valid) {
            this.$emit("addoreditOrg", this.rootForm);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("common.invalidForm") + "！",
            });
          }
        });
      } else if (
        this.drawerType == "addChild" ||
        this.drawerType == "editChild"
      ) {
        this.$refs["userFormAddChild"].validate((valid) => {
          if (valid) {
            //  if(childForm.type=="DEPARTMENT"){//部门
            this.$emit("addoreditOrg", this.childForm);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
}
/* .bottomBtns { */
/* text-align: center;
  margin-left:-20px;
  width: 675px;
  height:60px;
  line-height:60px;
  background-color: white; */
/* } */
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
.line {
  display: inline-block;
  height: 18px;
  width: 2px;
  background: #303133;
  margin-right: 5px;
}
.classTitle {
  height: 32px;
  line-height: 32px;
  font-size: 18px;
}
form {
  margin-bottom: 30px;
}
.addDrawerTitle {
  margin-bottom: 20px;
}
.fixedBottom {
  position: fixed;
  bottom: 0;
  right: 155px;
}
::v-deep .el-drawer__body {
  /* position: relative; */
}
::v-deep .el-input__inner {
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 2px;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 420px !important;
}
::v-deep .el-drawer__open .el-form-item__content {
  width: 380px !important;
}
::v-deep .el-form-item__label {
  display: block !important;
  width: 380px !important;
  text-align: left !important;
}
::v-deep .el-input,
.el-select {
  width: 380px !important;
}
::v-deep .shortSelect > .el-input {
  width: 120px !important;
}
</style>
